import { searchIcon } from '../utils/svgs';
import '../styles/Search.css';

const Search = ({ value, onChange }) => {
    return (
        <div className='search_box_main_div'>
            {searchIcon}
            <input
                type="text"
                placeholder='Search'
                value={value}
                onChange={onChange}
            />
        </div>
    )
}

export default Search